import { apiCall } from '../../utils';
import { authApiCall } from '../auth/saga';

export const getCoupons = (params) =>
  authApiCall({
    url: '/affiliate-coupons/rakuten-coupons/',
    method: 'get',
    params,
  });

export const getProductsByMids = (params) =>
  authApiCall({
    url: '/affiliate-coupons/rakuten-products/',
    method: 'get',
    params,
  });

export const getBusinesses = () =>
  authApiCall({
    url: '/affiliate-coupons/rakuten-approved-mids/',
    method: 'get',
  });

